import { HStack } from '@chakra-ui/layout'
import { FC } from 'react'

import { AmhUnit } from '@gaia-family/lib'

import { InputProps } from '../Input'
import { NumberInput } from '../Number'
import { RadioGroup } from '../Radio'

const unitOptions = [
  { name: 'ng/ml', value: AmhUnit.NanogramsPerMilliliter },
  { name: 'pmol/L', value: AmhUnit.PicomolesPerLitre },
]

export type AmhProps = {
  value: Gaia.Amh | null
  onChange: (amh: Gaia.Amh) => void
  name?: string
} & Pick<InputProps, 'variant' | 'onFocus' | 'onBlur'>

export const AmhInput: FC<AmhProps> = ({
  variant,
  value: amh,
  onChange,
  onBlur,
  onFocus,
  name,
}) => {
  const toggleUnit = (newUnit: AmhUnit) => {
    onChange({
      unit: newUnit,
      value: 0,
    })
  }

  const unit = amh?.unit || unitOptions[0].value

  const displayUnit =
    amh?.unit === AmhUnit.PicomolesPerLitre ? 'pmol/L' : 'ng/ml'
  return (
    <HStack spacing="sm" width="100%" maxWidth="article">
      <NumberInput
        key={amh?.unit}
        placeholder={displayUnit}
        value={amh?.value}
        variant={variant}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={(value) =>
          onChange({
            unit,
            value: value ?? 0,
          })
        }
        name={name}
      />
      <RadioGroup
        options={unitOptions}
        value={unit}
        name="unit"
        onChange={toggleUnit}
      />
    </HStack>
  )
}
